import { render, staticRenderFns } from "./FieldWrapper.vue?vue&type=template&id=08bcd9de"
import script from "./FieldWrapper.vue?vue&type=script&lang=ts"
export * from "./FieldWrapper.vue?vue&type=script&lang=ts"
import style0 from "./FieldWrapper.vue?vue&type=style&index=0&id=08bcd9de&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports